import { ViewIcon } from '@chakra-ui/icons'
import { HStack, Text } from '@chakra-ui/react'
import { Collection, CollectionItem, Template, TemplateKey } from '@hb/shared'
import React, { useContext, useMemo, useState } from 'react'
import { TemplateContext } from '../../contexts'
import { ActionButton } from '../Buttons/ActionButton'
import { Container } from '../Container'
import { EditedProps } from '../EditHeader'
import { TemplateViewModal } from './TemplateViewModal'

export const TemplatePreview: React.FC<
  EditedProps<Template> & {
    collection: Collection<Template>
    item: CollectionItem<Template>
    templateType: TemplateKey
  }
> = ({ item, collection, templateType }) => {
  const { id } = item ?? {}
  const { select } = useContext(TemplateContext)
  return (
    <Container
      style={{
        height: 'auto',
        margin: 0,
        padding: '0 1rem',
        boxSizing: 'border-box',
        alignItems: 'flex-start',
      }}>
      <ActionButton
        colorScheme="gray"
        size="xs"
        mb={2}
        onClick={
          id && select
            ? () => select({ collection, templateId: id, templateType })
            : () => console.error('No select function! :(')
        }>
        View / Edit {item?.name || 'template'}
      </ActionButton>
    </Container>
  )
}

export const StandaloneTemplatePreview: React.FC<{
  collection: Collection<Template>
  templateType: TemplateKey
  practiceId: string | null
  item?: CollectionItem<Template>
}> = ({ item, collection, templateType, practiceId }) => {
  const { id, name } = item ?? {}
  const [viewingTemplate, setViewingTemplate] = useState(false)
  const selectedTemplate = useMemo(
    () => (id ? { collection, templateId: id, templateType } : null),
    [id, collection, templateType],
  )
  const contextData = useMemo(
    () => ({
      selected: selectedTemplate,
      select: () => {},
      deselect: () => setViewingTemplate(false),
      ref: { current: null },
    }),
    [selectedTemplate],
  )

  const autoTemplateId = useMemo(
    () =>
      id
        ? {
            templateId: id,
            practiceId,
          }
        : null,
    [id, practiceId],
  )

  return (
    <HStack p={2} w="100%">
      <Text flex={1} minW="0" fontFamily="Open Sans">
        {name}
      </Text>
      <ActionButton
        as="div"
        size="xs"
        gap={1}
        // color='gray.500'
        maxW="200px"
        onClick={e => {
          e.stopPropagation()
          setViewingTemplate(true)
        }}>
        <ViewIcon />
        <Text flex={1} isTruncated maxW="100%" minW="0">
          View Template
        </Text>
      </ActionButton>
      {viewingTemplate ? (
        <TemplateContext.Provider value={contextData}>
          <TemplateViewModal
            autoTemplateId={autoTemplateId}
            readOnly
            user={null}
            type={templateType}
            isOpen
            onClose={() => setViewingTemplate(false)}
          />
        </TemplateContext.Provider>
      ) : null}
    </HStack>
  )
}
